/* Trampolin insights-button behavior (R6.3, 2026-07-05).
 * Extracted from snippets/insights-button.liquid, where the ~45-line handler
 * was re-emitted inline at every render site (8 render sites in the theme).
 * Every render site still emits its own <script src> tag; the browser fetches
 * this file once and the __tlInsightsButtonsBound guard keeps the delegated
 * listener idempotent across repeated executions.
 */
(function () {
  if (window.__tlInsightsButtonsBound) return;
  window.__tlInsightsButtonsBound = true;

  function scrollToAddButton() {
    var productTitle = document.querySelector('.tl-product-title');
    if (productTitle) {
      window.scrollTo({
        top: productTitle.offsetTop - 150,
        behavior: 'smooth',
      });
      return;
    }
    var addButton = document.querySelector('button[name="add"]');
    if (addButton) {
      addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function handleLinkClick(event, link) {
    if (typeof link !== 'string' || link.length === 0) return;
    if (link.charAt(0) === '#' || link.charAt(0) === '.') {
      event.preventDefault();
      var element = document.querySelector(link);
      if (element) element.click();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var btn = target.closest('[data-tl-button-action]');
    if (!btn) return;

    var action = btn.dataset.tlButtonAction;
    if (action === 'scroll-to-top') {
      event.preventDefault();
      scrollToAddButton();
      return;
    }
    if (action === 'link') {
      handleLinkClick(event, btn.dataset.tlLink || btn.getAttribute('href') || '');
    }
  });
})();
